import { useCallback } from 'react';
import type { LocaleGetter } from '@engage/internationalize/dateTime';
import { useLocale } from './useLocale';

export const useLocaleGetter = (): LocaleGetter => {
  const locale = useLocale();
  return useCallback(() => locale, [locale]);
};
